export default "__VITE_ASSET__CVbg0ZML__"